<template>
    <li :class="{ 'nav-item': true, 'section': isSection }" >
        <router-link v-if="link.Action"
                :to="link.Action"
                @click.native="linkClick"
                class="nav-link"
                :target="link.target"
                :href="link.Action">
            <template>
                <i :class="link.Icon"></i>
                <span class="nav-link-text">{{ link.Name }}</span>
            </template>
        </router-link>
        <template v-for="cMod in link.Children">
          <sidebar-item v-bind:key="cMod.EntityID" :link="{Name: cMod.Name, Icon: cMod.Icon, Action: cMod.Action, Children: cMod.Children}" />
        </template>
    </li>
</template>
<script>
  export default {
    name: 'sidebar-item',
    props: {
      link: {
        type: Object,
        default: () => {
          return {
            Name: '',
            Action: null,
            Icon: '',
            Children: [],
            IsLast: false,
          };
        },
        description:
          'Links'
      }
    },
    inject: {
      autoClose: {
        default: true
      }
    },
    data() {
      return {
        children: [],
        collapsed: true
      };
    },
    methods: {
      linkClick() {
        if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
        ) {
          this.$sidebar.displaySidebar(false);
        }
      }
    },
    computed: {
      isSection(){
        return this.link.Action == null || this.link.Action == '';
      }
    }
  };
</script>
<style scoped>
  .section
  {
    border-bottom: 1px solid rgb(208, 208, 208);
  }
</style>
